module.exports = __webpack_public_path__ + "static/media/loader.a3ddd1e7.svg";